export default "__VITE_ASSET__Debpy9g4__"